var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.care_vital_sign.care_has_vital_signs.length > 0)?_c('div',[_c('p',{class:[
      'm-0 text-thirteen upper-text',
      parseInt(_vm.item.description) >= 60 &&
        parseInt(_vm.item.description) <= 100 &&
        'color-green',
      parseInt(_vm.item.description) >= 101 &&
        parseInt(_vm.item.description) <= 139 &&
        'color-orange',
      parseInt(_vm.item.description) >= 41 &&
        parseInt(_vm.item.description) <= 59 &&
        'color-orange',
      parseInt(_vm.item.description) >= 140 &&
        parseInt(_vm.item.description) <= 40 &&
        'color-red' ]},[_vm._v(" "+_vm._s(_vm.item.description)+" "+_vm._s(_vm.item.abbreviation)+" ")]),_c('p',{staticClass:"mb-1 worksansr text-twelve upper-text"},[_vm._v(" CADASTRADO POR: "+_vm._s(_vm.item.user_name)+" ")]),_c('hr')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }